import { createContext, useContext } from "react";
import useAuth from "./useAuth";

/**
 * Kliniğin etkin modülleri (bkz. sunucu shared/permissions/clinic-modules.config.js).
 *
 * İzne bağlı yerler (menü, sekmeler, uçlar) modülü zaten sunucudaki izin süzmesiyle
 * kendiliğinden izler. Bu kanca izne bağlı OLMAYAN yerler içindir: form alanları,
 * dashboard kartları, şablon başlıkları.
 *
 * Kaynak sırası: ClinicModulesContext (admin bir kliniğin hasta detayını açınca o
 * kliniğin modülleri) → oturumdaki klinik (personel). İkisi de yoksa (admin kendi
 * panelinde) her şey açık sayılır.
 */
export const ClinicModulesContext = createContext(null);

export const useActiveModules = () => {
  const fromContext = useContext(ClinicModulesContext);
  const { auth } = useAuth();
  if (Array.isArray(fromContext)) return fromContext;
  const list = auth?.clinic?.activeModules;
  return Array.isArray(list) ? list : null;
};

/** Modül etkin mi? Liste bilinmiyorsa (eski oturum, admin) true. */
export const useClinicModule = (key) => {
  const list = useActiveModules();
  return !list || list.includes(key);
};

/** Liste verilen modül anahtarı için true/false döndüren yardımcı. */
export const moduleChecker = (list) => (key) => !key || !Array.isArray(list) || list.includes(key);

export default useClinicModule;
